import React, { useState, useEffect, useContext } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// Import React Icons
import {
 FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, 
} from 'react-icons/fa';
import { FiClock } from 'react-icons/fi';
import { GlobalContext } from '../../context/GlobalContext';

// Styled components
const FooterContainer = styled(Box)(({ theme }) => ({
  backdropFilter: 'blur(8px)',
  backgroundColor: 'transparent',
  borderTop: '1px solid rgba(255, 255, 255, 0.08)',
  position: 'relative',
  padding: theme.spacing(1.5), // Reduced padding
  marginTop: 'auto',
  transition: 'all 0.3s ease',
}));

const SocialIconButton = styled('button')({
  color: 'rgba(5, 5, 5, 0.8)',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  margin: '0 4px',
  padding: '6px',
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease',
  '&:hover': {
    color: '#4fc3f7',
    transform: 'translateY(-2px)',
  },
});

const ClockDisplay = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  color: 'rgba(5, 5, 5, 0.8)',
  fontSize: '0.8rem',
  marginLeft: '10px',
});

const Footer = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const { apiGlobal } = useContext(GlobalContext);
  
  useEffect(() => {
    // Update date every second
    const intervalId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);
    
    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
  
  // Format the date and time in a compact format
  const formattedDateTime = currentDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

   const [formData, setFormData] = useState({
      copyrightContent: '',
      facebook: '',
      instagram: '',
      linkedin: '',
      twitter: '',
    });


  const fetchFooterSetting = async () => {
      try {
        const res = await fetch(`${apiGlobal}/get_footer_setting.php`, {
          method: 'POST',
        });
        const response = await res.json();
  
        if (response?.status && response?.message === 'Success' && response?.data) {
          const { data } = response;
          setFormData({
            copyrightContent: data?.copyright_text || '',
            facebook: data?.facebook || '',
            instagram: data?.instagram || '',
            linkedin: data?.linkedin || '',
            twitter: data?.twitter || '',
          });
        } else {
          console.warn('No footer data found.');
        }
      } catch (error) {
        console.error('Error fetching footer data:', error);
      }
    };
  
    useEffect(() => {
      fetchFooterSetting();
    }, []);
  
  return (
    <FooterContainer>
      <Container>
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap',
          justifyContent: 'center',
          float: 'center',
          // justifyContent: 'space-around',
          gap: 1, 
        }}
        >
          {/* Left side content */}
          <Box>
            <Typography variant="caption" sx={{ color: 'rgba(5, 5, 5, 0.8)' }}>
              ©️ {formData?.copyrightContent} | Developed by MVD-TECH
            </Typography>
          </Box>
          |
          {/* Right side content */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Social icons */}
            <Box sx={{ display: 'flex' }}>
              {formData.facebook && (
              <SocialIconButton
                as="a"
                href={formData.facebook}
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <FaFacebookF size={14} />
              </SocialIconButton>
  )}
              {formData.twitter && (
              <SocialIconButton
                as="a"
                href={formData.twitter}
                target="_blank"
                rel="noopener noreferrer"
                title="Twitter"
              >
                <FaTwitter size={14} />
              </SocialIconButton>
  )}
              {formData.instagram && (
              <SocialIconButton
                as="a"
                href={formData.instagram}
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <FaInstagram size={14} />
              </SocialIconButton>
  )}
              {formData.linkedin && (
              <SocialIconButton
                as="a"
                href={formData.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
              >
                <FaLinkedinIn size={14} />
              </SocialIconButton>
  )}
            </Box>

            
            {/* Date and time */}
            <ClockDisplay>
              <FiClock size={14} style={{ marginRight: 6 }} />
              <Typography variant="caption">{formattedDateTime}</Typography>
            </ClockDisplay>
          </Box>
        </Box>
      </Container>
    </FooterContainer>
  );
};

export default Footer;


// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Footer = () => {
//   const [currentDate, setCurrentDate] = useState(new Date());
  
//   useEffect(() => {
//     // Update date every second
//     const intervalId = setInterval(() => {
//       setCurrentDate(new Date());
//     }, 1000);
    
//     // Clean up interval on component unmount
//     return () => clearInterval(intervalId);
//   }, []);
  
//   // Format the date
//   const formattedDate = currentDate.toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//   });
  
//   return (
//     <footer className="bg-dark text-white py-3 mt-auto ">
//       <div className="container">
//         <div className="row">
//           <div className="col-12 text-center">
//             <span>©️ 2025 BITEVIZE.COM All Right Reserved | Developed by MVD-TECH | </span>
//             <span>{formattedDate}</span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
